import { TimeUnitKey } from 'types';

import { formatValue } from '../filters-helpers';

export default (
    zoomStartIdx: number,
    zoomEndIdx: number,
    xAxisValues: string[] | number[],
    timeUnitKey: TimeUnitKey,
    localizer
): object => {
    const start = xAxisValues[zoomStartIdx];
    const end = xAxisValues[zoomEndIdx];
    let range = '';
    if (start != null && end != null) {
        const formatter = (value) => formatValue(timeUnitKey, value, localizer);
        range = start === end ? formatter(start) : `${formatter(start)} to ${formatter(end)}`;
    }

    return { start, end, range };
};
